// src/lib/utils.ts
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// src/components/shell/EmptyState.tsx
import { jsx, jsxs } from "react/jsx-runtime";
function EmptyState({
  icon,
  title,
  description,
  action,
  className
}) {
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: cn(
        "flex flex-col items-center justify-center gap-3 py-12 text-center",
        className
      ),
      children: [
        icon && /* @__PURE__ */ jsx("div", { className: "text-muted-foreground", children: icon }),
        /* @__PURE__ */ jsx("h3", { className: "text-base font-semibold", children: title }),
        description && /* @__PURE__ */ jsx("p", { className: "max-w-md text-sm text-muted-foreground", children: description }),
        action && /* @__PURE__ */ jsx("div", { className: "mt-2", children: action })
      ]
    }
  );
}
export {
  EmptyState
};
//# sourceMappingURL=EmptyState.js.map